<p>product-weight works!</p>
